import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { disableAnonCreation, useUser } from '../../hooks/useUser';
import { useAuth } from '../../hooks/useAuth';
import {
  getPortalBranding,
  resolvePortalSourceId,
  getLoanTypeLabel,
} from '../../utils/portalBranding';
import PreQualFunnelLayout from '../PreQualFunnelLayout';
import LendAPIFunnelHeaderRight from '../../shared/components/LendAPIFunnelHeaderRight';

const LendAPICombinedLogout: React.FC = observer(() => {
  const user = useUser();
  const auth = useAuth();
  const sourceId = resolvePortalSourceId(window.location.search, window.location.hostname);
  const { boatLoansUrl, label } = getPortalBranding(sourceId);
  const loanTypeLabel = getLoanTypeLabel(label);

  useEffect(() => {
    disableAnonCreation();
    auth.signOut();
  }, [auth]);

  return (
    <PreQualFunnelLayout headerRight={<LendAPIFunnelHeaderRight />}>
      {user && !user.isAnonymous ? (
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h1>You have been logged out</h1>
          <h3 style={{ marginTop: '1rem', fontWeight: 'normal' }}>
            To learn more about {loanTypeLabel}, click{' '}
            <a
              href={boatLoansUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              here
            </a>
            .
          </h3>
        </div>
      )}
    </PreQualFunnelLayout>
  );
});

export default LendAPICombinedLogout;
